import React, { PureComponent } from 'react';

export interface CustomIconIndicatorProps {
  className?: string;
  link?: string;
  targetLink?: string;
  disabled?: boolean;
}

export class CustomIconIndicator extends PureComponent<CustomIconIndicatorProps> {
  render() {
    return (
      <span className={this.props.className}>
        {this.props.link ? (
          <a
            href={this.props.link}
            target={this.props.targetLink || '_blank'}
            className={'link' + (!this.props.disabled ? '' : ' disabled')}
            onClick={(e) => {
              if (!this.props.disabled) {
                e.stopPropagation();
              }
            }}
          >
            {this.props.children}
          </a>
        ) : (
            this.props.children
          )}
      </span>
    );
  }
}
